export default "__VITE_ASSET__BJcyre2k__"